import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-071b23c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "HandledValue" }
const _hoisted_2 = {
  key: 0,
  class: "HandledValue__current"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isRenderingOldValue || _ctx.isRenderingCurrentValue)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.oldValues, (oldValue, i) => {
            return (_openBlock(), _createElementBlock("span", {
              key: `old-value-${i}`,
              class: "HandledValue__old"
            }, [
              (_ctx.isRenderingUnit)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(oldValue) + " " + _toDisplayString(_ctx.unit), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(oldValue), 1)
                  ], 64))
            ]))
          }), 128)),
          (_ctx.isRenderingCurrentValue)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                (_ctx.isRenderingUnit)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.currentValue) + " " + _toDisplayString(_ctx.unit), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(" - ")
        ], 64))
  ]))
}